// extracted by mini-css-extract-plugin
export default {"container":"PopUpModal_container__IAp2U","closeModalIcon":"PopUpModal_closeModalIcon__rzfle"};